module.exports = __webpack_public_path__ + "static/media/signup-left-ellipse.aed0831b.png";